<template>
  <b-card class="gray-card mb-0">
    <div class="row mb-2">
      <div class="col-md-6">
        <h5 class="m-0">{{ lodash.startCase(cardTitle) }}</h5>
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <div
            class="d-flex align-items-center gap-2 p-1"
            style="background: white; border-radius: 8px; border: 1px solid #EAECF0"
        >
          <template v-for="(tab, index) of tabs">
            <b-button
                :key="`button-${tab.key}`"
                :variant="locationActiveTabIndex === index ? 'primary' : 'white'"
                style="border-radius: 4px; padding: 4px 8px;"
                @click="locationActiveTabIndex = index"
            >
              {{ tab.text }}
            </b-button>
          </template>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <validation-provider
          v-if="tabs[locationActiveTabIndex].key === 'gmap-link'"
          vid="gmap_link"
          :name="lodash.startCase($t('jala_farms.gmap_link'))"
          rules=""
          v-slot="{ validated, errors }"
      >
        <b-form-group
            class="row"
            label-cols-md="12"
            :state="errors[0] ? false : validated ? true : null"
            :invalid-feedback="errors[0]"
            label-class="d-none"
        >
          <b-form-input
              placeholder="ex: https://maps.app.goo.gl/xxx"
              name="gmap_link"
              type="text"
              :state="errors[0] ? false : validated ? true : null"
              v-model="farm.coordinate_link"
              @update="val => onCoordinateLinkUpdated(val)"
          />
          <b-form-text id="coordinate-live-help">{{$t('customers.gmap_link_text_help')}}</b-form-text>
        </b-form-group>
      </validation-provider>
      <validation-provider
          vid="coordinate"
          :name="lodash.startCase($t('jala_farms.coordinate'))"
          rules=""
          v-slot="{ validated, errors }"
      >
        <b-form-group
            class="row"
            label-cols-md="12"
            :state="errors[0] ? false : validated ? true : null"
            :invalid-feedback="errors[0]"
            label-class="d-none"
        >
          <b-form-input
              placeholder="ex:-6.1753083,106.8245357"
              name="coordinate"
              type="text"
              :state="errors[0] ? false : validated ? true : null"
              v-model="farm.coordinate"
              :disabled="tabs[locationActiveTabIndex].key === 'gmap-link'"
          />
          <latlng-picker
              class="mt-2"
              :center="region
              ? {
                  lat: Number(region.latitude),
                  lng: Number(region.longitude),
                }
              : { lat: -6.2, lng: 106.816666 }"
              :zoom="region ? region.id.length + 3 : 7"
              map-type-id="hybrid"
              v-model="farm.coordinate"
          >
          </latlng-picker>
        </b-form-group>
      </validation-provider>
    </div>
  </b-card>
</template>

<script>
import LatlngPicker from "@/components/inputs/latlng-picker";

export default {
  name: "customer-coordinate",
  components: {
    LatlngPicker,
  },
  props: {
    cardTitle: {
      type: String,
      default: function () {
        return this.$t('customers.location')
      },
    },
    farm: {
      type: Object,
      required: true,
    },
    region: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      locationActiveTabIndex: 0,
      tabs: [
        { key: "coordinate", text: this.lodash.startCase(this.$t("customers.coordinate")) },
        { key: "gmap-link", text: this.lodash.startCase(this.$t("customers.gmap_link")) },
      ],
    };
  },
  methods: {
    onCoordinateLinkUpdated(link) {
      if (!link) {
        this.$set(this.farm, "coordinate", null);
        return;
      }
      this.postExtractCoordinate(link).then((res) => {
        const {
          data: { data },
        } = res;
        this.farm.coordinate = `${data.lat},${data.lng}`;
      });
    },
    postExtractCoordinate(link) {
      return this.$axios.post("google-maps/extract-coordinates", {
        link,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .gray-card {
    .card-body {
      background-color: #f9fafb;
      border-radius: 8px;
    }
  }
}
</style>
